import { useEffect } from 'react'

import { setTopButtonBottomMargin } from '@web/components/TopButton/TopButton'
import useCheckinAccess from '@web/hooks/useCheckinAccess/useCheckinAccess'
import { useGoTo } from '@web/hooks/useGoTo'
import CheckInButton from '@web/ui/components/CheckInButton'

const CheckInButtonContainer = () => {
  const { goToCheckIn } = useGoTo()
  const { validateAccess } = useCheckinAccess({ onSuccess: goToCheckIn })

  // 기존 TOP 버튼 때문에 남겨둠
  useEffect(() => {
    setTopButtonBottomMargin(76)
    return () => {
      setTopButtonBottomMargin(null)
    }
  }, [])

  return <CheckInButton onClick={validateAccess} />
}

export default CheckInButtonContainer
